module.exports = __webpack_public_path__ + "static/media/icon-user-white.00fc3a5f.svg";